import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface Licensor {
  LICENSOR: string;
  _id: string;
}

interface LicensorState {
  data: Licensor[];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedLicensor: string[];
  selectedLicensorList: string[];
}
const initialState: LicensorState = {
  data: [],
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  selectedLicensor: [],
  selectedLicensorList: [],
};

export const fetchLicensor = createAsyncThunk(
  "fetchLicensor",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHLICENSOR, data);
      return response;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const LicensorSlice = createSlice({
  name: "LicensorData",
  initialState,
  reducers: {
    UpdateSelectedLicensor: (state, action) => {
      state.selectedLicensor = action.payload;
    },
    UpdateSelectedLicensorList: (state, action) => {
      state.selectedLicensorList = action.payload;
    },
    emptyLicensorReducer: (state) => {
      state.data = initialState.data;
      state.status = initialState.status;
      state.error = initialState.error;
      state.statusCode = initialState.statusCode;
      state.isLoading = initialState.isLoading;
      state.selectedLicensor = initialState.selectedLicensor;
      state.selectedLicensorList = initialState.selectedLicensorList;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLicensor.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(fetchLicensor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(fetchLicensor.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const {
  UpdateSelectedLicensor,
  UpdateSelectedLicensorList,
  emptyLicensorReducer,
} = LicensorSlice.actions;
export default LicensorSlice.reducer;


